import React from 'react';
import { motion } from 'framer-motion';
import { Award } from 'lucide-react';

const DeanMessageSection = () => {
  return (
    <section className="relative overflow-hidden py-16 md:py-24" style={{ background: 'linear-gradient(180deg, #fdf9f2 0%, #ffffff 60%)' }}>
      {/* Dekoratif arka plan lekeleri */}
      <div className="absolute -top-40 -left-40 w-[26rem] h-[26rem] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(123,13,30,0.08) 0%, transparent 70%)' }} />
      <div className="absolute -bottom-40 -right-40 w-[26rem] h-[26rem] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(212,175,55,0.14) 0%, transparent 70%)' }} />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        <motion.div
          className="flex justify-center mb-8 md:mb-10"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.24em] px-4 py-2 rounded-full" style={{
            background: 'rgba(123,13,30,0.07)',
            color: '#7B0D1E',
          }}>
            <Award className="w-3 h-3" />
            Dekanımızdan
          </span>
        </motion.div>

        {/* Masaüstü / tablet: tasarlanmış görsel */}
        <motion.div
          className="hidden md:block relative mx-auto"
          style={{ maxWidth: '920px' }}
          initial={{ opacity: 0, y: 28, scale: 0.98 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.75, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <div
            className="rounded-[1.75rem] p-[3px]"
            style={{ background: 'linear-gradient(135deg, #D4AF37 0%, #7B0D1E 45%, #D4AF37 100%)', boxShadow: '0 30px 80px rgba(123,13,30,0.22), 0 0 0 1px rgba(123,13,30,0.06)' }}
          >
            <motion.div
              className="rounded-[calc(1.75rem-3px)] overflow-hidden bg-white"
              whileHover={{ scale: 1.008 }}
              transition={{ type: 'spring', stiffness: 300, damping: 24 }}
            >
              <img
                src="/dekanaciklama.png"
                alt="Dekanımızın 55. Kuruluş Yıldönümü Açıklaması"
                className="w-full h-auto block"
              />
            </motion.div>
          </div>
        </motion.div>

        {/* Mobil: okunabilir metin kartı */}
        <motion.div
          className="md:hidden relative mx-auto rounded-3xl p-[2px]"
          style={{ maxWidth: '520px', background: 'linear-gradient(135deg, #D4AF37 0%, #7B0D1E 45%, #D4AF37 100%)', boxShadow: '0 20px 50px rgba(123,13,30,0.18)' }}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="rounded-[calc(1.5rem-2px)] bg-white px-6 py-8">
            <div className="text-center mb-6">
              <img src="/fenfakultesilogo.png" alt="" aria-hidden="true" className="w-12 h-12 mx-auto mb-3 object-contain" />
              <h3 className="font-black leading-tight" style={{ color: '#7B0D1E', fontSize: '1.35rem' }}>
                55. Kuruluş Yıldönümümüz
              </h3>
              <p className="italic mt-0.5" style={{ color: '#D4AF37', fontFamily: 'Georgia, serif', fontSize: '1.4rem' }}>
                Kutlu Olsun
              </p>
            </div>

            <div className="text-gray-600 text-[13.5px] leading-relaxed space-y-3.5">
              <p>Hacettepe Üniversitesi Fen Fakültesi olarak, 23 Ağustos 1971'de başlayan bilim ve eğitim yolculuğumuzun 55. yılını gurur ve mutlulukla kutluyoruz.</p>
              <p>Kuruluşundan bu yana bilimin evrensel değerlerini rehber edinen Fakültemiz; Biyoloji, Kimya, Matematik, İstatistik ve Aktüerya Bilimleri alanlarında nitelikli eğitim, özgün araştırma ve topluma katkı anlayışıyla ülkemizin bilimsel gelişimine önemli katkılar sunmuştur.</p>
              <p>Geçmişten bugüne Fakültemizin gelişmesine emek veren değerli akademik ve idari personelimize, bilimsel birikimimizi geleceğe taşıyan öğrencilerimize ve mezunlarımıza, ayrıca çalışmalarımıza destek veren tüm paydaşlarımıza içtenlikle teşekkür ediyorum.</p>
              <p>Köklü geçmişimizden aldığımız güçle; bilimin ışığında üreten, araştıran, sorgulayan ve geleceğe yön veren bir fakülte olma sorumluluğumuzu Gazi Mustafa Kemal ATATÜRK'ün <em>"hayatta en hakiki mürşit ilimdir"</em> anlayışından aldığımız ilhamla, aynı kararlılıkla sürdüreceğiz.</p>
              <p>Hacettepe Üniversitesi Fen Fakültesinin 55. kuruluş yıldönümünü kutluyor; Fakültemizin bugünlere ulaşmasında emeği bulunan tüm mensuplarımıza saygı ve teşekkürlerimi sunuyorum.</p>
            </div>

            <div className="text-center mt-6 pt-5 border-t border-gray-100">
              <p className="font-bold text-gray-800 text-sm">Prof. Dr. Hatice MERGEN</p>
              <p className="text-[11px] uppercase tracking-[0.18em] mt-0.5" style={{ color: '#7B0D1E' }}>Dekan</p>
            </div>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default DeanMessageSection;
